"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createArraySchemaComponent = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
const fieldWrapper_1 = require("../common/fieldWrapper");
const react_sortable_hoc_1 = require("react-sortable-hoc");
const react_hook_form_1 = require("react-hook-form");
const createArraySchemaComponent = (selectorGenerator) => (props) => {
    var _a;
    const { schema, fieldPath, control, readOnly } = props;
    const { fieldState, value } = (0, core_1.useField)(props, [core_1.requiredValidator]);
    const { fields, remove, move, insert, update, append } = (0, react_hook_form_1.useFieldArray)({
        control,
        name: fieldPath,
    });
    const [moving, setMoving] = (0, react_1.useState)(false);
    if (schema.readOnly || readOnly) {
        return (react_1.default.createElement(ArrayReadOnlySchemaComponent, Object.assign({}, props, { selector: selectorGenerator() })));
    }
    const onSortEnd = ({ oldIndex, newIndex, }) => {
        move(oldIndex, newIndex);
        setMoving(false);
    };
    const onSortStart = () => {
        setMoving(true);
    };
    const onAdd = (index) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        insert(index, schema.defaultValue || "");
    };
    const onRemove = (index) => {
        var _a;
        remove(index);
        (_a = schema.autoSaveHandler) === null || _a === void 0 ? void 0 : _a.call(schema);
    };
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState },
        react_1.default.createElement("div", { className: (0, classnames_1.default)("array-wrapper", moving && "array-wrapper-moving") },
            react_1.default.createElement(SortableList, { onSortEnd: onSortEnd, onSortStart: onSortStart, useDragHandle: true },
                react_1.default.createElement("button", { type: "button", className: "btn text-primary fs-5 button-icon mdi mdi-plus-circle-outline", style: {
                        cursor: "pointer",
                    }, onClick: () => { var _a; return onAdd((_a = schema.reservedIndexes) !== null && _a !== void 0 ? _a : 0); } }), (_a = fields.map) === null || _a === void 0 ? void 0 :
                _a.call(fields, (field, index) => {
                    var _a;
                    // const displayIndex = index + (schema.reservedIndexes ?? 0);
                    return (react_1.default.createElement("div", { key: field.id, style: {
                            display: index < ((_a = schema.reservedIndexes) !== null && _a !== void 0 ? _a : 0) ? "none" : "block",
                        } },
                        react_1.default.createElement(SortableItem, Object.assign({}, props, { index: index, schema: schema.item, fieldPath: (0, core_1.joinFieldPath)(fieldPath, `${index}`), onRemove: () => onRemove(index), selector: selectorGenerator() })),
                        react_1.default.createElement("button", { onClick: () => onAdd(index + 1), type: "button", className: "btn text-primary fs-5 button-icon mdi mdi-plus-circle-outline" })));
                })))));
};
exports.createArraySchemaComponent = createArraySchemaComponent;
const ArrayReadOnlySchemaComponent = (props) => {
    var _a;
    const { schema, fieldPath, control, selector: Field } = props;
    const { fieldState } = (0, core_1.useField)(props, [core_1.requiredValidator]);
    const { fields } = (0, react_hook_form_1.useFieldArray)({
        control,
        name: fieldPath,
    });
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState, fullWidth: true },
        react_1.default.createElement("div", { className: (0, classnames_1.default)("array-wrapper") }, (_a = fields === null || fields === void 0 ? void 0 : fields.map) === null || _a === void 0 ? void 0 : _a.call(fields, (field, index) => (react_1.default.createElement("div", { key: field.id },
            react_1.default.createElement("div", { className: "field-decoration-wrapper", style: {} },
                react_1.default.createElement("div", { className: "field-decoration-content" },
                    react_1.default.createElement(Field, Object.assign({}, props, { schema: schema.item, fieldPath: (0, core_1.joinFieldPath)(fieldPath, `${index}`) }))))))))));
};
const DragHandle = (0, react_sortable_hoc_1.SortableHandle)(({ children }) => (react_1.default.createElement(react_1.default.Fragment, null, children)));
const SortableItem = (0, react_sortable_hoc_1.SortableElement)((props) => {
    const Field = props.selector;
    return (react_1.default.createElement("div", { className: "field-decoration-wrapper", style: {} },
        react_1.default.createElement("div", { className: "field-decoration", style: { marginRight: 5 } },
            react_1.default.createElement(DragHandle, null,
                react_1.default.createElement("label", { className: "label" },
                    react_1.default.createElement("span", null,
                        react_1.default.createElement("i", { style: {
                                cursor: "grab",
                            }, className: "mdi mdi-drag-vertical text-primary fs-5" })),
                    react_1.default.createElement("button", { type: "button", onClick: props.onRemove, className: "btn button-icon mdi mdi-close-circle-outline text-primary fs-5" })))),
        react_1.default.createElement("div", { className: "field-decoration-content" },
            react_1.default.createElement(Field, Object.assign({}, props)))));
});
const SortableList = (0, react_sortable_hoc_1.SortableContainer)(({ children }) => {
    return react_1.default.createElement("div", { style: { position: "relative" } }, children);
});
